import React from "react";
import { Search, SlidersHorizontal } from "lucide-react";
import { CategoryTabs } from "./CategoryTabs";

// App-like sticky mobile header: floating search capsule + category pill scroller.
export const MobileExploreHeader = ({ onOpenSearch, title, subtitle, activeCount = 0, category, setCategory }) => (
  <div className="md:hidden sticky top-0 z-40 bg-paper/95 backdrop-blur-xl border-b border-black/5" data-testid="mobile-explore-header">
    <div className="px-4 pt-3 flex items-center gap-2.5">
      <button onClick={onOpenSearch} data-testid="mobile-search-capsule"
        className="flex-1 min-w-0 min-h-[52px] rounded-full bg-white border border-black/10 shadow-[0_8px_24px_-10px_rgba(20,20,20,0.28)] px-4 py-2 flex items-center gap-3 text-left active:scale-[0.98] transition-transform">
        <Search className="w-5 h-5 text-ink shrink-0" aria-hidden="true" />
        <span className="min-w-0">
          <span className="block font-heading font-bold text-[0.9rem] text-ink truncate leading-tight">{title}</span>
          <span className="block text-xs text-ink-faint truncate">{subtitle}</span>
        </span>
      </button>
      <button onClick={onOpenSearch} aria-label="Filters" data-testid="mobile-filters-btn"
        className="relative shrink-0 w-11 h-11 rounded-full border border-black/10 bg-white flex items-center justify-center active:scale-95 transition-transform">
        <SlidersHorizontal className="w-[18px] h-[18px] text-ink" aria-hidden="true" />
        {activeCount > 0 && (
          <span data-testid="mobile-filters-badge" className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-brand text-white text-[10px] font-bold flex items-center justify-center">
            {activeCount}
          </span>
        )}
      </button>
    </div>
    <CategoryTabs pill category={category} setCategory={setCategory} />
  </div>
);

export default MobileExploreHeader;
